import { useQuery } from "@tanstack/react-query";
import { URLS } from "../../../infra/URLS";
import { getProdutosTipo } from "../queries/getProdutoTipo";

export function useGetProdutosTipo(search? : number) {

  const resultQuery = useQuery([URLS.PRODUTOS_TIPO_API], () => getProdutosTipo(search));

  return resultQuery;
}